<template>
  <div class="authenticate">
    <h1>Authenticate</h1>
    <input type="password" v-model="token">
    <button @click="authenticate">Authenticate</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: localStorage.getItem('token') || ''
    }
  },
  methods: {
    authenticate() {
      localStorage.setItem('token', this.token);
      this.$router.push('/shows');
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Authenticate.vue